import {apiSlice} from './apiSlice';

/**
 * Endpoints tool Site Crawler (bên trong một Project).
 *
 * - getProjectCrawls: thông tin project + lịch sử các lần crawl (trang tool crawler).
 * - runCrawl: bắt đầu 1 lần crawl với cấu hình (max_depth/max_pages/delay/robots).
 * - getCrawlStatus: FE POLL tiến độ khi đang running (pollingInterval set ở component).
 * - getCrawlReport: báo cáo đầy đủ Tầng A + Tầng B khi crawl xong.
 * - getCrawlPage: chi tiết 1 trang (trả eval_json để tái dùng component SeoResult).
 *
 * Quản lý Project (CRUD) nằm ở reduxs/api/projectApiSlice.js.
 */
export const crawlerApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getProjectCrawls: builder.query({
			query: (projectId) => ({url: `crawler/projects/${projectId}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, projectId) => [{type: 'Crawl', id: `project-${projectId}`}],
		}),
		runCrawl: builder.mutation({
			query: ({projectId, ...config}) => ({url: `crawler/projects/${projectId}/run`, method: 'post', data: config}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: (result, error, {projectId}) => [{type: 'Crawl', id: `project-${projectId}`}],
		}),
		getCrawlStatus: builder.query({
			query: (id) => ({url: `crawler/crawls/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Crawl', id}],
		}),
		getCrawlReport: builder.query({
			query: (id) => ({url: `crawler/crawls/${id}/report`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'Crawl', id: `report-${id}`}],
		}),
		getCrawlPage: builder.query({
			query: (id) => ({url: `crawler/pages/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
		}),
		deleteCrawl: builder.mutation({
			query: (id) => ({url: `crawler/crawls/${id}`, method: 'delete'}),
			invalidatesTags: ['Crawl'],
		}),
	}),
});

export const {
	useGetProjectCrawlsQuery,
	useRunCrawlMutation,
	useGetCrawlStatusQuery,
	useGetCrawlReportQuery,
	useGetCrawlPageQuery,
	useDeleteCrawlMutation,
} = crawlerApiSlice;
